import * as React from "react";

import { Button, type ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** Compact circular icon control for message/inbox/channel hover toolbars. */
export function ToolbarIconButton({
  className,
  size = "icon",
  variant = "ghost",
  ...props
}: ButtonProps) {
  return (
    <Button
      variant={variant}
      size={size}
      className={cn("h-7 w-7 shrink-0 rounded-full", className)}
      {...props}
    />
  );
}

/** Emoji reaction chip inside message action bars. */
export const TOOLBAR_EMOJI_BUTTON =
  "rounded-full p-1 text-sm leading-none hover:bg-foreground/10 hover:text-foreground";
